import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api/axios.config';
import { notify } from '../utils/methods/notification';

const initialState = {
    isLoading: false,
    allStorageLocation: [],
    storageLocationDropdown: [],
    addModal: false
};

// fetch all storage locations
export const fetchAllStorageLocation = createAsyncThunk(
    'bmr/fetchAllStorageLocation',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/storage_locations');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// add storage location
export const addStorageLocation = createAsyncThunk(
    'bmr/addStorageLocation',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.post('/storage_locations/create', args);
            notify.success(response.data.message);
            dispatch(disableAddModal());
            dispatch(fetchAllStorageLocation());
            return response.data;
        } catch (error) {
            notify.error(error || error.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// edit storage location
export const editStorageLocation = createAsyncThunk(
    'bmr/editStorageLocation',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { data, editId } = args;
            const response = await api.put(`/storage_locations/update/${editId}`, data);
            notify.success(response.data.message);
            dispatch(disableAddModal());
            dispatch(fetchAllStorageLocation());
            return response.data;
        } catch (error) {
            notify.error(error?.message || error);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// delete storage location
export const deleteStorageLocation = createAsyncThunk(
    'bmr/deleteStorageLocation',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { id } = args;
            const response = await api.delete(`/storage_locations/${id}`);
            notify.success(response.data.message);
            dispatch(fetchAllStorageLocation());
            return response.data;
        } catch (error) {
            notify.error(error?.message || error);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// @info get Esential patient for the portal 1
export const fetchStorageLocationDropDown = createAsyncThunk(
    'bmr/fetchStorageLocationDropDown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get(`/storage_locations/active/status`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

const bmrStorageLocationSlice = createSlice({
    name: 'bmrStorageLocation',
    initialState,
    reducers: {
        enableAddModal(state) {
            state.addModal = true;
        },
        disableAddModal(state) {
            state.addModal = false;
        },
    },
    extraReducers: (builder) => {
        builder
            // fetch
            .addCase(fetchAllStorageLocation.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllStorageLocation.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allStorageLocation = action.payload.data;
            })
            .addCase(fetchAllStorageLocation.rejected, (state) => {
                state.isLoading = false;
            })
            // add
            .addCase(addStorageLocation.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(addStorageLocation.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(addStorageLocation.rejected, (state) => {
                state.isLoading = false;
            })
            // edit
            .addCase(editStorageLocation.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(editStorageLocation.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(editStorageLocation.rejected, (state) => {
                state.isLoading = false;
            })
            // delete
            .addCase(deleteStorageLocation.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteStorageLocation.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteStorageLocation.rejected, (state) => {
                state.isLoading = false;
            })
            // dropdown
            .addCase(fetchStorageLocationDropDown.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchStorageLocationDropDown.fulfilled, (state, action) => {
                state.isLoading = false;
                state.storageLocationDropdown = action.payload.data.items?.map(op => { return { value: op?.id, label: op.name } })
            })
            .addCase(fetchStorageLocationDropDown.rejected, (state) => {
                state.isLoading = false;
            });
    },
});

export const { disableAddModal, enableAddModal } = bmrStorageLocationSlice.actions;

export const selectStorageLocationLoading = (state) => state.bmrStorageLocation.isLoading;
export const selectStorageLocationAll = (state) => state.bmrStorageLocation.allStorageLocation;
export const selectStorageLocationDropdown = (state) => state.bmrStorageLocation.storageLocationDropdown;
export const selectBmrAddStorageLocationModal = (state) => state.bmrStorageLocation.addModal;

export default bmrStorageLocationSlice.reducer;
